import React, { useState } from 'react';
import supabase from '../helper/supabaseClient';
import { Link, useNavigate } from 'react-router-dom';

function Login ({ switchToRegister}) {

  const navigate = useNavigate();
  const [email,setEmail ] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    const {data, error} = await supabase.auth.signInWithPassword({
      email: email,
      password: password,
    });

    if (error) {
      setMessage("Invalid login credentials");
      setEmail("");
      setPassword("");
      return;
    }

    if (data) {
      navigate("/dashboard");
      return null;
    }
  };

  
    return (
      <div>
        <h2 style={{fontSize: "1.6rem"}}>PLEASE LOG IN</h2>
        
        <form className="login" onSubmit={handleSubmit}> 
          <input
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            placeholder="Email"
            required/>
          <br></br>
          
          <input 
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            placeholder="Password"
            required/>
          <br></br>

          <button type="submit">Login</button>
        </form>
        <br></br>

        {message && <p className="error-message">{message}</p>}
        

        <p>New user? <span className="clickable"
        onClick={switchToRegister}>Click here to register</span></p>

        <p>Forgot your password? <Link to="/password">Click here to reset your password.</Link></p>
      </div>
    )
}

export default Login